export interface CollaborationProject {
  id: string;
  name: string;
  description: string;
  createdBy: string;
  createdAt: Date;
  lastUpdated: Date;
  collaborators: Collaborator[];
  status: string;
  thumbnail?: string;
  type: string;
}

export interface Collaborator {
  id: string;
  name: string;
  role: string;
  avatarUrl?: string;
  status: string;
  joinedAt?: Date;
}

// Mock data for projects
export const mockCollaborationProjects = [
  {
    id: "1",
    name: "Summer EP Recording",
    description: "Recording sessions for the upcoming summer EP release",
    thumbnail: "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cmVjb3JkaW5nJTIwc3R1ZGlvfGVufDB8fDB8fHww",
    status: "In Progress",
    type: "Recording",
    createdBy: "Jamie Collins",
    createdAt: new Date("2024-01-15"),
    lastUpdated: new Date("2024-02-28"),
    collaborators: [
      {
        id: "u1",
        name: "Jamie Collins",
        role: "Producer",
        status: "Owner",
        joinedAt: new Date("2024-01-15")
      },
      {
        id: "u2",
        name: "Alex Turner",
        role: "Vocalist",
        status: "Active",
        joinedAt: new Date("2024-01-16")
      },
      {
        id: "u3",
        name: "Sam Wilson",
        role: "Guitarist",
        status: "Active",
        joinedAt: new Date("2024-01-18")
      }
    ]
  },
  {
    id: "2",
    name: "Winter Tour Preparation",
    description: "Rehearsal sessions for the upcoming winter tour",
    thumbnail: "https://images.unsplash.com/photo-1501612780327-45045538702b?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGNvbmNlcnR8ZW58MHx8MHx8fDA%3D",
    status: "Planned",
    type: "Rehearsal",
    createdBy: "Jamie Collins",
    createdAt: new Date("2024-02-01"),
    lastUpdated: new Date("2024-02-01"),
    collaborators: [
      {
        id: "u1",
        name: "Jamie Collins",
        role: "Manager",
        status: "Owner",
        joinedAt: new Date("2024-02-01")
      },
      {
        id: "u4",
        name: "Taylor Swift",
        role: "Vocalist",
        status: "Invited",
        joinedAt: null
      }
    ]
  }
];
